module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/uploadimage/asset/upload.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/uploadimage/asset/upload.png
// module id = 1289
// module chunks = 367